const externalApiUrl = 'https://dev-external-api.labelinsight.com'
const offPackageLoader = 'https://dev-internal-api.labelinsight.com/off-package-loader'

export default {
  roles: 'https://dev-verification-api.labelinsight.com/rest/',
  aggregateApi: 'https://dev-verification-api.labelinsight.com/rest/smartlabel/aggregate',
  previewApi: 'https://smartlabel-dev-api.labelinsight.com/rest/preview/v3',
  offPkgUpc: `${offPackageLoader}/api/offpackage/bulkUpload/upc-fragrance`,
  offPkgDictionary: `${offPackageLoader}/api/offpackage/bulkUpload/component-dictionary`,

  bulkIngredientToggle: `${externalApiUrl}/smartlabel-data-scrubber-api/rest/bulk/ingredient/toggle/field/visibility`,
  bulkAddClaims: `${externalApiUrl}/smartlabel-data-scrubber-api`,
  productStatusApi: `${externalApiUrl}/verification-bulk-editing-api/rest/bulk/status/`,
  workflow: `${externalApiUrl}/verification-dashboard-api/workflow/`,
  button: `${externalApiUrl}/verification-dashboard-api/`,
  editing: `${externalApiUrl}/verification-editing-api/`,
  bulkEditing: `${externalApiUrl}/verification-bulk-editing-api`,
  rebuildElasticsearchData:
    `${externalApiUrl}/verification-editing-api/brandProductVerification/smartlabel/elasticsearch/rebuild`,

  labelSyncConfigSearch:
    'https://api-dev.labelinsight.com/labelsync-configuration/label-sync/configuration/organization',

  defaultEdit: {
    organization: {
      fetch: `${externalApiUrl}/verification-bulk-editing-api/rest/defaultEdit/org/`,
      submit: `${externalApiUrl}/verification-bulk-editing-api/rest/defaultEdit/org/`,
      delete: `${externalApiUrl}/verification-bulk-editing-api/rest/defaultEdit/org/`
    },
    productGroup: {
      fetch: `${externalApiUrl}/verification-bulk-editing-api/rest/defaultEdit/productGroup/`,
      submit: `${externalApiUrl}/verification-bulk-editing-api/rest/defaultEdit/productGroup/`,
      delete: `${externalApiUrl}/verification-bulk-editing-api/rest/defaultEdit/productGroup/`
    }
  },
  auth: {
    env: 'development'
  }
}



// WEBPACK FOOTER //
// ./src/config/environments/development.js